module.exports = __webpack_public_path__ + "img/sell-car768x432.d98e39ae.png";